export const programs = [
  {
    id: 1,
    title: "THE DROP-IN CENTRE",
    shortDescription:
      "A temporary safe loving haven for girls and women in need.",
    detailedDescription: `<p>A temporary loving safe heaven for girls and women in need (between 14 years to 26 years
of age ) facing abuse, child marriage, teen pregnancy and are abandoned; the Drop-In
Centre is a safe haven of hope. Here, they find shelter, care, and a chance to start again.</p><br/>
      
      <p>We provide emergency shelter, counseling, life skills, vocational trainings and health
support, helping survivors heal, regain dignity, and reclaim their lives. Every day, we
witness courage in the face of hardship—and transformation in those we serve.</p> <br/>

      <p>Our goal is to stabilize individuals in crisis and connect them with longer-term resources and support systems. We work closely with local social services, healthcare providers, and community organizations to ensure comprehensive care.</p>
      
      <p>By supporting the Drop-In Centre, you are standing with the most vulnerable, restoring
hope, and giving lives a chance to flourish. Together, we can turn fear into freedom,
despair into possibility, and crisis into a brighter future.</p>`,
    image: "/images/our-programs-1.jpg",
    gallery: [
      { image: "/images/pg-drop-1.jpeg" },
      { image: "/images/pg-drop-2.jpeg" },
      { image: "/images/pg-drop-3.jpeg" },
    ],
    impact:
      "380+ Pregnant girls rescued, given medical care, shelter & supported through Child birth",
    goal: "Expand to 500 students by 2026",
  },
  {
    id: 2,
    title: "FORTRESS DIGNITY KITS",
    shortDescription:
      "Silent Thief of Potential Project empowers Ugandan girls to reclaim their education.",
    detailedDescription: `<p>Thousands of Ugandan girls miss nearly two months of school each year simply because they lack sanitary products. Forced to use unhygienic rags or leaves, they endure isolation and shame that robs them of their potential.</p><br/>
      
      <p>The crisis is urgent and heartbreaking:</p><br/>
      
      <ul>
        <li><strong>School Dropouts:</strong> 30% of girls leave school due to menstruation-related challenges.</li>
        <li><strong>Gender-Based Violence:</strong> Missing school increases vulnerability to child marriage and abuse.</li>
        <li><strong>Teen Pregnancy:</strong> 1 in 4 girls becomes pregnant by age 18, closing the door on future opportunities.</li>
      </ul><br/>
      
      <p>Our solution is simple but transformative: Dignity Kits and menstrual hygiene training. One reusable kit reclaims 20% of the school year, boosting graduation chances by over 50%.</p><br/>
      
      <p>We must act now to replace fear with confidence. Your partnership turns lost days into a lifetime of power. Every girl deserves to lead with dignity, and together we can make that a reality.</p>`,
    image: "/images/pg-dignity-1.jpeg",
    gallery: [
      { image: "/images/pg-dignity-2.jpeg" },
      { image: "/images/pg-dignity-3.jpeg" },
      { image: "/images/pg-dignity-4.jpeg" },
    ],
    impact:
      "820+ Girls with re-usable sanitary packages called Dignity Kits + hygiene trainings.",
    goal: "Gift 50,000+ Dignity Kits annually",
  },
  {
    id: 5,
    title: "GAREP",
    shortDescription:
      "Girls At-Risk Empowerment Project serves girls in risky environments.",
    detailedDescription: `<p>The Girls At-Risk Empowerment Project (GAREP) is designed to reach and support girls
and boys living in high-risk environments and schools. We work proactively to provide
alternatives to dangerous situations, giving girls and boys hope, safety, awareness and
opportunity before harm finds them.</p><br/>
      
      <p>Through GAREP, we create pathways to safety, knowledge, opportunity, and empowerment:</p><br/>
      
      <ul>
        <li><strong>Trainings and Outreach:</strong> Education through life skills trainings in
            purpose, decision making, self defense and advocacy to keep the girls longer in
            school.
        </li>
        <li><strong>Skill Development:</strong> Equipping girls with life skills, leadership, and confidence.</li>
        <li><strong>Menstrual Hygiene trainings and supplies:</strong> many girls cannot afford hygienic menstrual kits so we provide them.</li>
      </ul><br/>
      
      <p>Our school and community-based approach ensures lasting change and stronger support networks.</p>
      
      <p>Your support can change a life. Every donation, every act of advocacy, and every moment
          you stand with these girls helps provide safety, education, and hope. Together, we can
          empower the most vulnerable to rise, thrive, and create a brighter tomorrow.
      </p>`,
    image: "/images/our-programs-2.jpg",
    gallery: [
      { image: "/images/pg-grep-1.jpeg" },
      { image: "/images/pg-grep-2.jpeg" },
      { image: "/images/pg-grep-3.jpeg" },
    ],
    impact:
      "6+ Women & Girls Conferences and Trainings regarding Parenting Skills, Nutrition, Self worth and Financial empowerment",
    goal: "Hold 20+ outreaches annually",
  },
  {
    id: 3,
    title: "EDUCATION AND SKILLING",
    shortDescription:
      "Girls and women are empowered through skilling and education.",
    detailedDescription: `<p>Education and skilling form the cornerstone of our empowerment strategy. We believe that knowledge and practical skills are fundamental tools that enable girls and women to break cycles of poverty and dependence.</p>
      
      <p>Our comprehensive education and skilling program includes:</p>
      
      <ul>
        <li><strong>Formal Education Support:</strong> Assistance with school enrollment, fees, supplies, and tutoring for girls who have fallen behind or been out of school.</li>
        <li><strong>Vocational Training:</strong> Hands-on training in various trades including tailoring, hairdressing, catering, and crafts.</li>
        <li><strong>Digital Literacy:</strong> Computer skills and internet literacy to prepare participants for the modern economy.</li>
        <li><strong>Entrepreneurship Development:</strong> Business planning, financial management, and market access support for those who want to start their own enterprises.</li>
        <li><strong>Leadership Training:</strong> Programs designed to develop confidence, public speaking skills, and community leadership abilities.</li>
      </ul>
      
      <p>We work with certified instructors and partner with established institutions to ensure our participants receive quality training that leads to recognized qualifications.</p>
      
      <p>Our graduates have gone on to start successful businesses, complete higher education, and become leaders in their communities. The program not only transforms individual lives but also strengthens entire families and communities.</p>`,
    image: "/images/our-programs-3.jpg",
    gallery: [
      { image: "/images/pg-eduskill-1.jpeg" },
      { image: "/images/pg-eduskill-2.jpeg" },
      { image: "/images/pg-eduskill-3.jpeg" },
    ],
    impact: "4,700+ Girls Empowered with Life Skills",
    goal: "Skill and educate 10,000+ women and girls",
  },
  {
    id: 4,
    title: "WOMAN OF PURPOSE COMMUNITY OUTREACH",
    shortDescription:
      "Focused on helping women in the community through both on station training, and outreaches.",
    detailedDescription: `<p>The Woman of Purpose Community Outreach program extends our services beyond our center
                              walls to reach women in their own communities. We recognize that many women face barriers to
                              accessing our center-based services, including transportation, childcare responsibilities, or
                              cultural constraints.</p><br/>
      
      <p>Our community outreach model includes:</p><br/>
      
      <ul>
        <li><strong>Mobile Services:</strong> Teams that travel to underserved areas to provide on-site training and support in parenting skills, women empowerment, financial literacy etc.</li>
        <li><strong>Women conferences and seminaries:</strong> We organize conferences and seminaries to empower women in self value, esteem, parenting, financial literacy etc.</li>
        <li><strong>Mama kits distribution and prenatal trainings:</strong> We provide free life saving mama kits and trainings to pregnant mothers in the communities.</li>
        <li><strong>Peer Education Networks:</strong> Training community members to become health and empowerment advocates in their own neighborhoods.</li>
        <li><strong>Resource Distribution:</strong> Providing essential items like hygiene kits, educational materials, and information about available services.</li>
      </ul><br/>
      
      <p>Our outreach approach is flexible and responsive to community needs.</p><br/>
      
      <p>The program has been particularly effective in reaching marginalized populations too. By bringing services directly to communities, we've been able to impact thousands of women who might otherwise not have access to our programs.</p>
      
      <p>Through this program, we're not just serving individuals but building community capacity for long-term change and resilience.</p>`,
    image: "/images/our-programs-4.jpg",
    gallery: [
      { image: "/images/pg-wop-1.jpeg" },
      { image: "/images/pg-wop-2.jpeg" },
      { image: "/images/pg-wop-3.jpeg" },
    ],
    impact: "1,650+ Community Outreaches",
    goal: "Create 5,000 sustainable jobs",
  },
];

// Helper function to find a program by ID
export function getProgramById(id) {
  return programs.find((program) => program.id === parseInt(id));
}

// Helper function to get all program IDs for static generation
export function getAllProgramIds() {
  return programs.map((program) => program.id.toString());
}
